export const getOtherVersionsLabel = (versions: string[]): string => {
	let output = 'How would you like that?';

	const normalizedVersions = versions
		.map(version => version.toLowerCase().split(''))
		.map(([first, ...rest]) => [first.toUpperCase(), ...rest].join(''));

	switch (versions.length) {
		case 2: {
			const [first, second] = normalizedVersions;

			output = `${first} or ${second}?`;

			break;
		}
		case 3: {
			const [first, second, third] = normalizedVersions;

			output = `${first}, ${second}, or ${third}?`;

			break;
		}
	}

	return output;
};
